import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisbursDtlsCompComponent } from './disburs-dtls-comp.component';
import { MaterialModule } from "src/app/shared/material/material.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    DisbursDtlsCompComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule
],
  exports:[
    DisbursDtlsCompComponent
  ]
})
export class DisbursDtlsCompModule { }
